import { inject, Injectable } from '@angular/core';
import { API_MAP } from 'app/core/helpers/api.map';
import { environment } from 'environments/environment';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { BehaviorSubject, catchError, EMPTY, Observable, retry, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreloadedRecaptchaApiService {
  public ready?: Observable<ReCaptchaV2.ReCaptcha>;

  constructor() {
    const scriptElement = document.createElement('script');
    scriptElement.src = `${API_MAP.rechaptchaUrl}${environment.recaptcha.siteKey}`;
    document.head.appendChild(scriptElement);
    scriptElement.onload = () => {
      console.log('Recaptcha loaded!');
      let readySubject = new BehaviorSubject<ReCaptchaV2.ReCaptcha>(grecaptcha);
      this.ready = readySubject.asObservable();
    };

    scriptElement.onerror = () => {
      console.log('Recaptcha error!');
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  // This ReCaptcha breaks sometimes on init()
  readonly #recaptchaV3Service: ReCaptchaV3Service | null = null;

  constructor() {
    try {
      this.#recaptchaV3Service = inject(ReCaptchaV3Service, { optional: true });
    } catch (error) {
      console.error(`RecaptchaService:`, error);
    }
  }

  getRecaptchaToken(action: string): Observable<string> {
    return this.#recaptchaV3Service
      ? this.#recaptchaV3Service?.execute(action)?.pipe(
        retry({ count: 3, delay: 1000 }),
        catchError((error) => {
          console.error(error);
          return throwError(() => new Error(error))
        })
      )
      : throwError(() => new Error('unable load recaptcha'));
  }
}
